import { useState } from "react";

import Text from "ab-text";
import Button from "ab-button";

const MenuItem = ({ title, description, options = [] }) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div className="item">
      <div className="detail">
        <div>
          <Text element="h2">{title}</Text>
          {description ? (
            <Text className="title">
              {isOpen ? description : `${description.substr(0, 75)}...`}
            </Text>
          ) : null}
        </div>

        <Button
          type={isOpen ? "menos" : "mas"}
          onClick={() => setIsOpen(!isOpen)}
        />
      </div>
      <div className="prices">
        {options && options?.length &&
          options.map((itm) => (
            <div className={isOpen ? "show" : undefined}>
              <span>{itm.label}</span>
              <span>{itm.price}</span>
            </div>
          ))}
      </div>
    </div>
  );
};

export default MenuItem;
